export default {
    'Banner列表':'Banner List',  
    '应用端':'App Side',  
    '位置':'Position',  
    '编辑banner':'Edit Banner',  
    '添加图片':'Add Image',  
    '固定banner':'Fixed Banner',  
    '图片':'Image',  
    '链接到':'Link To',  
    '链接地址':'Link URL',  
    '上传banner图':'Upload Banner Image',  
    '最多只可以同时存在五张轮播图哦！':'A maximum of 5 carousel images can exist at the same time!',  
    '取消后，页面数据不再保存':'Data will not be saved after cancellation',  
    '确认要删除该bannner图吗？':'Confirm to delete this bannner image?',  

    //5.16
    '关闭后，将不在本机构显示此banner':'After closing, this banner will no longer be displayed in this institution',
    '开启后，将在本机构显示此banner':'After opening, this banner will be displayed in this institution',
    '确认要删除吗':'Are you sure you want to delete it?',
    '发布机构':'Issuing institution:',
    '开启关闭':'Turn on/off',
    '不能上移啦': "It can't be moved up ~",
    '不能下移啦': "It can't be moved down ~",

}